module.exports = __webpack_public_path__ + "assets/img/36_451.4d6c7b9a.jpg";